import React from 'react'
import styled from 'styled-components';
function Developer() {
  return (
    <Container>
      <div class="container">
    <h1>Developer</h1>
    <p>Introducing Ayush Solanki</p>
    <p>I'm currently working on: Expanding my experience in full-stack development with JavaScript frameworks such as React, Next, and MERN stack.</p> 

<p>I'm looking to collaborate on: Projects that involve using innovative technologies to solve complex problems in the web development industry.</p> 

<p>I'm looking for help with: Improving my skills in scaling web applications and implementing secure payment processing.</p> 
<p>I'm currently learning: Advanced algorithms and data structures to optimize the performance of web applications and improve user experience.</p> 

    <ul>
      <li>Email: <a href="mailto:ayushsolanki.developer@gmail.com"> ayushsolanki.developer@gmail.com</a></li>
    </ul>

    <h2>Project Info</h2>
    <p>Project: Universal Chat <code>version : 2.0.0 </code></p>
    <p>Universal Chat is a real-time chat application built with React, Node.js, and Socket.io. It provides a seamless and interactive chatting experience.</p>
    
    <h3>Technology Stack</h3>
    <ul>
      <li>React</li>
      <li>Node.js</li>
      <li>Socket.io</li>
      <li>MongoDB</li>
      <li>Express</li>
      <li>Styled Components</li>
    </ul>
  </div>
    </Container>
  )
}
const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  margin-top: 2%;
  color:#fff;
  
  .container {
    align-items: center;
    text-align:start;
    height: 100%;
    min-height:100vh;
    width: 85vw;
    background-color: #00000076;
    display: grid;
    grid-template-columns: 100% ;

    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }

  p {
    margin-bottom: 10px;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
    margin-bottom: 10px;
  }
  a{
    color:#fff;
  }
  }`;
export default Developer

